import { DocumentUpdate } from '../../document/models/request'
import createDocumentDeleter from '../../document/components/createDocumentDeleter'

interface DeleteConsignmentItemDocumentsProps {
  documentsToDelete: DocumentUpdate[]
}

export default function useDeleteConsignmentItemDocuments() {
  const deleteConsignmentItemDocuments = async ({ documentsToDelete }: DeleteConsignmentItemDocumentsProps) => {
    const deleteDocuments = createDocumentDeleter()
    return deleteDocuments(documentsToDelete)
  }

  return { deleteConsignmentItemDocuments }
}
